export default __webpack_public_path__ + "static/ky-6229ad59d24ee2228ac12f55cb0aab8f.svg";